import { useTranslation } from 'react-i18next'
import { getDateFnsLocale } from '../dateFnsLocales'
import { useMemo } from 'react'

export const useDateFnsLocale = () => {
  const [, { language }] = useTranslation()
  return useMemo(() => getDateFnsLocale(language), [language])
}
